import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon, GrcTreeView, IconProp } from '@grc/ui-package';
import { useCustomerPortalGlobalStore } from '../../../../stores/customer-portal-global-store';
import useSideMenu from './useSideMenu';
import LogoIcon from '../../../../common/icons/logo-icon';
import Loader from '../../../../common/loader';
import { getMenuItemTextByPath, MenuItems } from './menu';

import './side-menu.scss';

const SideMenu = () => {
  const location = useLocation();
  const [selectedMenu] = useCustomerPortalGlobalStore(
    store => store.menu.selectedMenu
  );
  const {
    onItemClick,
    treeViewCollapseAll,
    setSelectedMenu,
    isLoading,
    selectedParentId,
    treeViewRef,
    isSideNavOpened
  } = useSideMenu();

  useEffect(() => {
    const path = location.pathname;
    const parentTxt = getMenuItemTextByPath(path);
    const storedMenu = localStorage.getItem('selectedMenu');
    if (parentTxt) {
      localStorage.setItem('selectedMenu', parentTxt);
      setSelectedMenu(parentTxt);
    } else if (selectedMenu) {
      localStorage.setItem('selectedMenu', selectedMenu);
    } else if (storedMenu) {
      setSelectedMenu(storedMenu);
    }

    if (selectedParentId && isSideNavOpened) {
      treeViewRef?.current?.instance.expandItem(selectedParentId);
    } else {
      treeViewCollapseAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isSideNavOpened,
    treeViewRef,
    selectedParentId,
    setSelectedMenu,
    location.pathname,
    treeViewCollapseAll
  ]);

  return (
    <>
      <div className="side-nav-main-div">
        <div className="side-menu-layout">
          <div className="menu-collapse">
            <span className="logo">
              <LogoIcon />
            </span>
          </div>
          {!isLoading ? (
            <GrcTreeView
              id="simple-treeview"
              items={MenuItems}
              width={300}
              displayExpr="text"
              dataStructure="plain"
              parentIdExpr="parentId"
              treeViewRef={treeViewRef}
              itemRender={(item: any) => (
                <div className="menu-content">
                  <div className="icon-menu cursor-p">
                    {item?.icon && (
                      <FontAwesomeIcon
                        icon={item.icon as IconProp}
                        fontSize={22}
                        className="icon-work-nav-bar cursor-p"
                      />
                    )}
                  </div>
                  <div className="menu-name cursor-p"> {item.text} </div>
                </div>
              )}
              onItemClick={onItemClick}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </>
  );
};

export default SideMenu;
